import React from 'react';
import { TagProps, TagSize, TagVariant } from '../types';
import { cn } from '../../../../lib/utils';
import { motion } from 'framer-motion';
import { tagVariants, withReducedMotion, viewportOptions } from '../../../../lib/animations/variants';

const variantStyles: Record<TagVariant, string> = {
  default: 'bg-slate-100 text-slate-700 border-slate-200',
  primary: 'bg-sky-50 text-sky-700 border-sky-100',
  outline: 'bg-transparent border-slate-200 text-slate-700',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  muted: 'bg-slate-100 text-slate-500 border-slate-200'
};

const sizeStyles: Record<TagSize, string> = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-3 py-1',
  lg: 'text-base px-4 py-1.5'
};

export const Tag: React.FC<TagProps> = ({
  label,
  variant = 'default',
  size = 'md',
  icon,
  className,
  onClick
}) => {
  const baseStyles = 'inline-flex items-center rounded-full border font-medium transition-colors duration-200';
  const interactiveStyles = onClick ? 'cursor-pointer hover:bg-opacity-80' : '';

  const content = (
    <div 
      className={cn(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        interactiveStyles,
        className
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      {icon && (
        <span className="mr-1.5 -ml-0.5">
          {icon}
        </span>
      )}
      {label}
    </div>
  );
  
  return (
    <motion.div
        initial="hidden"
        animate="visible"
        whileHover="hover"
        variants={withReducedMotion(tagVariants)}
    >
      {content}
    </motion.div>
  );
};